/**
 * Змееголовые — 2 видов.
 *
 * ⚠️ ПОМЕТКИ «── ГДЕ ВОДИТСЯ ──» ПЕРЕЕХАЛИ СЮДА ВМЕСТЕ С РЫБОЙ. Вторая сотня
 * набиралась по краям света, и в прежнем файле виды стояли блоками: Иберия,
 * Балканы, Восточная Азия. Разрез по семействам эти блоки разнёс бы по
 * девятнадцати файлам, и знание о том, откуда вид, пропало бы вовсе — в коде
 * его больше нигде нет. Поэтому пометка идёт за своей рыбой.
 */
export const ЗМЕЕГОЛОВЫЕ = [
    // ── Амурские вселенцы ──
    {
        id: 'snakehead',
        семейство: 'змееголовые',
        latin: 'Channa argus',
        повадка: 'засадный',
        minKg: 0.5,
        maxKg: 10,
        typicalKg: 2,
        typicalLengthM: 0.6,
        depthM: 1.5,
        depthBandM: 1.5,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 12, опт: 26, макс: 33 },
        течение: 'стоячая',
        держится: ['трава', 'коряги', 'поверхность'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 6, по: 7 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'лягушка', вес: 0.8 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'jig', вес: 0.6 },
            { чем: 'spinner', вес: 0.4 },
            { чем: 'spoon', вес: 0.4 },
        ],
    },
    // ── Тропики и Южное полушарие ──
    {
        id: 'giant_snakehead',
        семейство: 'змееголовые',
        latin: 'Channa micropeltes',
        повадка: 'засадный',
        minKg: 0.8,
        maxKg: 12,
        typicalKg: 2.5,
        typicalLengthM: 0.7,
        depthM: 2,
        depthBandM: 1.5,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 20, опт: 28, макс: 34 },
        течение: 'стоячая',
        держится: ['трава', 'коряги', 'поверхность'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'лягушка', вес: 0.8 },
            { чем: 'jig', вес: 0.6 },
            { чем: 'spinner', вес: 0.4 },
            { чем: 'spoon', вес: 0.4 },
        ],
    },
];
//# sourceMappingURL=channids.js.map